import Vue from 'vue';
import App from '@/App.vue';
import http from '@/api/http.js'
import IMController from '@/assets/js/im.js'
import moment from 'moment';
Vue.prototype.$axios = http
Vue.config.productionTip = false
//引入vue-resource
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.prototype.im = IMController;
//引入router
import router from '@/router/index.js';
import store from './store/state.js'

Vue.prototype.store = store;
Vue.prototype.$moment = moment
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')

